/* eslint-disable no-unused-vars */
import Divider from 'components/shared/divider/horizontal'
import InquireForms from 'forms/public/inquire'
import Toggler from 'hoc/toggler'
import { WhatsAppIcon } from 'constants/imageMapping'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getFormValues, reset, touch } from 'redux-form'
import * as spaceActions from 'actions/spaces/types'

import Actions from '../include/actions'

const formName = 'traditional-inquire-form'

const TraditionalInquire = ({
  preSelectedSpace,
  spaces,
  id,
  formValues,
  inquireSubmit,
  dispatch,
}) => {
  const [selectedSpace, setSelectedSpace] = useState(spaces[0])

  useEffect(() => {
    !isEmpty(preSelectedSpace) && setSelectedSpace(preSelectedSpace)
  }, [preSelectedSpace])

  const resetForm = () => {
    dispatch(reset(formName))
  }
  const setFieldsTouched = () => {
    for (const key in formValues) {
      if (Object.hasOwnProperty.call(formValues, key)) {
        dispatch(touch(formName, key))
      }
    }
  }
  const handleClick = async (toggle) => {
    setFieldsTouched()

    await new Promise((resolve) => {
      inquireSubmit({ values: formValues, options: 'space', resolve, formName, resetForm })
    })

    toggle()
  }

  const renderInquire = () => (
    <div className="inquire inquire-building-form sticky-header-75 w-full bottom-0 right-0 left-0  lg:bg-transparent z-20 mx-auto lg:sticky lg:pl-15px">
      <div className="lg:rounded-lg bg-greytable py-6 mx-auto max-w-lg">
        <div className="flex flex-col w-full mx-auto">
          <div className="flex flex-col items-center justify-around px-4 lg:px-6 xl:px-8 ">
            <div className="building-inquiry-avt-container">
              <img src={preSelectedSpace.expertObj?.image} alt="" />
            </div>
            {<p className="text-black text-xl lato-reg">{preSelectedSpace.expertObj?.name}</p>}
            {/* for testing ui */}
            {preSelectedSpace.expertObj?.position && (
              <p className="text-secondary-greypricetype lato-reg">
                Singapore&lsquo;s local Space Expert!
              </p>
            )}
            <p className="bg-white border rounded-md flex contactInfoItem">
              <img className="mr-2" src={WhatsAppIcon} alt="whatsapp icon" />
              <a target="blank" href={preSelectedSpace.expertObj?.whatsappUrl}>
                Whatsapp
              </a>
            </p>
          </div>
          <div className="px-5 pt-4">
            <Divider className="mb-5 hidden lg:block" />
            <div className="lg:flex-grow flex text-center justify-center">
              <InquireForms
                className="w-full"
                submitButtonTitle="Send request"
                form={formName}
                handleClick={handleClick}
                initialValues={{
                  space_id: id,
                  notes: '',
                  firstName: '',
                  lastName: '',
                  email: '',
                  phone: '',
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Actions id={selectedSpace.id} />
    </div>
  )

  return selectedSpace && renderInquire()
}

TraditionalInquire.propTypes = {
  title: PropTypes.string,
  capacity: PropTypes.string,
  prices: PropTypes.array,
  spaces: PropTypes.array,
  place: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  showOption: PropTypes.bool,
  id: PropTypes.number,
  formValues: PropTypes.object,
  inquireSubmit: PropTypes.func,
  dispatch: PropTypes.func,
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({ space, ...state }) => {
  const formValues = getFormValues(formName)(state) || {}
  return {
    preSelectedSpace: space.spaceInfo || {}, // checks if the user is currently on the space page via checking the reducer
    id: space.spaceInfo.id,
    formValues,
  }
}
const mapDispatchToProps = (dispatch) => ({
  inquireSubmit: (payload) =>
    new Promise((resolve, reject) => {
      dispatch({ type: spaceActions.INQUIRE_SUBMIT, payload, resolve, reject })
    }),
  dispatch,
})
export default Toggler(connect(mapStateToProps, mapDispatchToProps)(TraditionalInquire), {
  canceledOnTouchOutside: false,
})
